<template>
  <!-- ========== Left Sidebar Start ========== -->
  
   
  <div @click="toggleSideNav()" class="left side-menu sideMenu" id="sideBar">
    
    <div class="slimscroll-menu sideNav" id="remove-scroll">
      <!--- Sidemenu -->
      <div id="sidebar-menu">
        <!-- Left Menu Start -->
        <ul class="metismenu" id="side-menu">
          <div class="dropdown-divider"></div>
          <li class="menu-title">YOUR BUSINESS</li>
          <li>
            <router-link to="/dashboard">
              <a href="#" class="waves-effect">
                <i class="fas fa-home"></i>
                <span>
                  Dashboard
                </span>
              </a>
            </router-link>
          </li>
          <li>
            <router-link to="/collection">
              <a href="#" class="waves-effect">
                <i class="far fa-credit-card"></i>
                <span>
                  Collection
                </span>
              </a>
            </router-link>
          </li>
          <li>
            <router-link to="/settlement">
            <a href="#" class="waves-effect">
              <i class="ti-wallet"></i>
              <span>
                Settlements
              </span>
            </a>
            </router-link>
          </li>
          
          <li v-if="Admin">
            <router-link to="/profile-settings">
            <a href="#" class="waves-effect">
              <i class="fas fa-user-cog"></i>
              <span>
                Profile/ Settings
              </span>
            </a>
            </router-link>
          </li>
          <li>
            <a @click="logout()" class="waves-effect">
              <i class="fas fa-sign-out-alt"></i>
              <span>Sign Out</span>
            </a>
          </li>
          <div class="dropdown-divider"></div>
          <li class="menu-title">SUPPORT</li>
          <li>
            <router-link to="/get-started">
            <a href="#" class="waves-effect">
              <i class="far fa-compass"></i>
              
                <span>Getting Started</span>
              
            </a>
            </router-link>
          </li>
          <li>
            <router-link to="/help">
            <a href="#" class="waves-effect">
              <i class="fas fa-question"></i>
              
                <span>Help Desk</span>
              
            </a>
            </router-link>
          </li>
          <div class="dropdown-divider"></div>
          <li class="menu-title">WEBSITE</li>
          <li>
            <a href="https://www.irecharge.ng" target="_blank" class="waves-effect">
              <i class="fas fa-tv"></i>
              <span>Go To iRecharge</span>
            </a>
          </li>
        </ul>
      </div>
      <!-- Sidebar -->

      <div class="clearfix"></div>
      <!-- -->
    </div>
    <!-- Sidebar -left -->
  </div>
  <!-- Left Sidebar End -->

 
</template>
<script>
export default {
  data() {
    return {
      level: null,
      Admin: false
    };
  },

   mounted() {
    this.level = sessionStorage.getItem("level")
    if(sessionStorage.getItem("level") == "admin")
    {
      this.Admin = true;
    }

  },

  methods: {
    logout() {
      sessionStorage.clear();
      this.$parent.visible = false;
      this.$router.push("login");
      //window.location.assign("http://localhost:8080/login");
    },
    toggleSideNav() {
      $("#sideBar").toggleClass("sideMenu");
    }
  }
};
</script>
<style>



  @media only screen and (max-width: 750px) {
    .sideMenu {
      display: none;
      transition:all 2s;
    }
    .side-menu {
      padding-left: 20%;
      width: 90%;
    }
  }


.moveInUp-enter-active {
  animation: fadeIn 2s ease-in;
}

@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  50% {
    opacity: 0.5;
  }
  100% {
    opacity: 1;
  }
}

.moveInUp-leave-active {
  animation: moveInUp 0.3s ease-in;
}

@keyframes moveInUp {
  0% {
    transform: translateY(0);
  }
  100% {
    transform: translateY(-400px);
  }
}
</style>